import { render, staticRenderFns } from "./ValintaBox.vue?vue&type=template&id=7136624e&scoped=true"
import script from "./ValintaBox.vue?vue&type=script&lang=js"
export * from "./ValintaBox.vue?vue&type=script&lang=js"
import style0 from "./ValintaBox.vue?vue&type=style&index=0&id=7136624e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7136624e",
  null
  
)

export default component.exports